//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Theme from "@/listing-app/mixins/Theme";
import TooltipControl from "@/listing-app/mixins/TooltipControl";

import Tooltip from "@/listing-app/components/detail/Tooltip";
export default {
  name: "Upgrades",
  mixins: [Theme, TooltipControl],
  props: ["data", "tooltips", "upgrade", "disabled"],
  components: {
    appTooltip: Tooltip,
  },
  data() {
    return {};
  },
  computed: {
    display() {
      let display = true;

      if (this.data == null || this.data.length === 0) {
        display = false;
      }
      if (this.data.length == 1 && this.data[0].Text.trim() == "") {
        display = false;
      }
      return display;
    },
  },
  methods: {
    set_upgrade(payload) {
			if (!this.disabled) {
				this.$emit("setUpgrade", payload);
			}
    },
  },
};
